import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls to the element named by the URL hash after navigation.
 *
 * App.js resets window scroll on pathname changes, so this waits a tick for
 * that reset, then honours the fragment. Used by the product page anchors
 * linked from the header.
 */
export function useHashScroll() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return undefined;
    const id = decodeURIComponent(hash.replace(/^#/, ''));
    if (!id) return undefined;

    const timer = window.setTimeout(() => {
      const target = document.getElementById(id);
      if (target && typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 60);

    return () => window.clearTimeout(timer);
  }, [hash]);
}

export default useHashScroll;
